import { render, staticRenderFns } from "./LclIText.vue?vue&type=template&id=26e32af3&scoped=true"
import script from "./LclIText.vue?vue&type=script&lang=js"
export * from "./LclIText.vue?vue&type=script&lang=js"
import style0 from "./LclIText.vue?vue&type=style&index=0&id=26e32af3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e32af3",
  null
  
)

export default component.exports